import { Box } from '@mui/material';
import OrganisationTable from 'components/administrationPanel/organisations/OrganisationTable';
import OrganisationModal from 'components/administrationPanel/organisations/OrganisationModal';
import SearchBar from 'components/shared/SearchBar';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AdministrationNavigation from 'components/administrationPanel/AdministrationNavigation';
import StyledButton from 'components/StyledButton';
import { AuthenticationContext } from 'components/AuthenticationProvider';
import { useNavigate } from 'react-router-dom';
import { Roles } from 'models/role.model';
import { ROUTE } from 'router/routes';

const OrganisationPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState<string>('');
  const [isEdition, setIsEdition] = useState(false);
  const [filter, setFilter] = useState<string>('');
  const { t } = useTranslation();
  const { roles } = useContext(AuthenticationContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!roles.includes(Roles.SuperAdministrator)) {
      navigate(ROUTE.PATIENTS.INDEX);
    }
  }, []);

  return (
    <Box
      component="main"
      sx={{
        p: '0 24px 32px 24px',
        m: 0,
        height: 'calc(100% - 64px)',
        width: '100vw',
      }}
    >
      <AdministrationNavigation currentPage={t('administrationPanel.organisations')} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <SearchBar onSearch={setFilter} placeholder={t('organisation.search')} />

        <StyledButton
          variant="contained"
          onClick={() => {
            setIsEdition(false);
            setIsOpen(true);
          }}
        >
          {t('organisation.add')}
        </StyledButton>
      </Box>

      <Box sx={{ height: 'inherit' }}>
        <OrganisationTable
          filter={filter}
          editOrganisation={(id: string) => {
            setId(id);
            setIsEdition(true);
            setIsOpen(true);
          }}
        />
      </Box>

      <OrganisationModal
        isEdition={isEdition}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        id={id}
      />
    </Box>
  );
};

export default OrganisationPage;
